import Swiper, {Navigation, Pagination, Thumbs} from 'swiper'

const ModalGallery = () => {

  const toggleGallery = document.querySelectorAll('.toggle-gallery')
  
  toggleGallery.forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelector('.modal-gallery').classList.toggle('active')
    })
  })

  const thumb = new Swiper('.thumbs-gallery-slider', {
    
    slidesPerView: 'auto',
    spaceBetween: 10,
    freeMode: true,
    watchSlidesProgress: true,

  })

  const swiper = new Swiper('.slides-gallery-slider', {
    modules: [Navigation, Pagination, Thumbs],
    
    slidesPerView: 1,
    loop: true,
    
    navigation: {
      nextEl: '.gallery .slider-button-prev',
      prevEl: '.gallery .slider-button-next',
    },
    
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    
    thumbs: {
      swiper: thumb,
    },

  })
}

export default ModalGallery